<div *ngIf="loadingService.unfinishedRequests" class="slider">
    <div class="line"></div>
    <div class="subline inc"></div>
    <div class="subline dec"></div>
</div>
<sm-terms-policy-cookies></sm-terms-policy-cookies>
<router-outlet></router-outlet>